import { Note } from "../note/Note"
import { ServiceFieldValueDetails } from "../service/ServiceFieldValueDetails"

export class QuoteServiceDetails {
  id: number
  description: string
  name: string
  notes: Note[]
  price: number
  serviceFieldValues: ServiceFieldValueDetails[]

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  constructor(id: number, description: string, name: string, notes: any, price: number, serviceFieldValues: any) {
    this.id = id
    this.description = description
    this.name = name
    this.price = price
    this.serviceFieldValues = serviceFieldValues as ServiceFieldValueDetails[]
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    this.notes = notes ? notes.map((n: any) => new Note(n.id, n.content, n.customerVisible, n.lastModifiedByUser, n.lastModifiedDate)) : []
  }
}